/* tslint:disable */
// @ts-nocheck
/* eslint-disable */
/**
 * Rana simulation API
 *
 * The version of the OpenAPI document: v3
 * Contact: info@nelen-schuurmans.nl
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
import type { ThreediModel } from "./ThreediModel";
import {
  ThreediModelFromJSON,
  ThreediModelFromJSONTyped,
  ThreediModelToJSON,
  ThreediModelToJSONTyped,
} from "./ThreediModel";

/**
 *
 * @export
 * @interface PaginatedThreediModelList
 */
export interface PaginatedThreediModelList {
  /**
   *
   */
  count: number;
  /**
   *
   */
  next?: string | null;
  /**
   *
   */
  previous?: string | null;
  /**
   *
   */
  results: Array<ThreediModel>;
}

/**
 * Check if a given object implements the PaginatedThreediModelList interface.
 */
export function instanceOfPaginatedThreediModelList(
  value: object
): value is PaginatedThreediModelList {
  if (!("count" in value) || value["count"] === undefined) return false;
  if (!("results" in value) || value["results"] === undefined) return false;
  return true;
}

export function PaginatedThreediModelListFromJSON(json: any): PaginatedThreediModelList {
  return PaginatedThreediModelListFromJSONTyped(json, false);
}

export function PaginatedThreediModelListFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): PaginatedThreediModelList {
  if (json == null) {
    return json;
  }
  return {
    count: json["count"],
    next: json["next"] === undefined ? undefined : json["next"] === null ? null : json["next"],
    previous:
      json["previous"] === undefined
        ? undefined
        : json["previous"] === null
        ? null
        : json["previous"],
    results: (json["results"] as Array<any>).map(ThreediModelFromJSON),
  };
}

export function PaginatedThreediModelListToJSON(json: any): PaginatedThreediModelList {
  return PaginatedThreediModelListToJSONTyped(json, false);
}

export function PaginatedThreediModelListToJSONTyped(
  value?: PaginatedThreediModelList | null,
  ignoreDiscriminator: boolean = false
): any {
  if (value == null) {
    return value;
  }

  return {
    count: value["count"],
    next: value["next"],
    previous: value["previous"],
    results: (value["results"] as Array<any>).map(ThreediModelToJSON),
  };
}
